
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface InvoiceAdditionalInfoCardProps {
  invoice: any;
}

const InvoiceAdditionalInfoCard: React.FC<InvoiceAdditionalInfoCardProps> = ({ invoice }) => {
  if (!invoice.payment_terms && !invoice.special_instructions) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Additional Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {invoice.payment_terms && (
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">Payment Terms</h3>
            <p className="text-sm">{invoice.payment_terms}</p>
          </div>
        )}
        {invoice.special_instructions && (
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">Special Instructions</h3>
            <p className="text-sm">{invoice.special_instructions}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default InvoiceAdditionalInfoCard;
